export default __webpack_public_path__ + "fonts/17847a42292bee096014e2e63f82dbe5.svg";